// extracted by mini-css-extract-plugin
module.exports = {"pinSize":"40","pin":"Pin_pin__1jI1t"};